<template>
  <div>
    <div class="d-flex justify-center pb-5">
      <img
        src="../assets/sellsuki-logo.png"
        alt="Sellsuki Logo"
        height="45">
    </div>

    <div class="font-weight-bold text-center pb-3 _fs-20">
      {{ titleTextData.th }}<br>
      เลขที่ {{ order.code }}
    </div>

    <div class="text-center">
      <span class="pr-3">
        วันที่
        <template v-if="order.createdAt">
          {{ order.createdAt | dateTimeFormat('DD/MM/YYYY') }}
        </template>
      </span>
      <span>
        ใช้ได้ถึง
        <template v-if="validAt">
          {{ validAt | dateTimeFormat('DD/MM/YYYY') }}
        </template>
      </span>
    </div>

    <v-divider class="my-6"></v-divider>

    <div class="font-weight-bold pb-5">
      ข้อมูลลูกค้า
    </div>
    <v-row no-gutters>
      <v-col
        class="pb-3"
        cols="4">
        ลูกค้า:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ order.companyName }}
      </v-col>
      <v-col
        class="pb-3"
        cols="4">
        ที่อยู่:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ addressText }}
      </v-col>
      <v-col
        class="pb-3"
        cols="4">
        เลขประจำตัวผู้เสียภาษี:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ order.citizenId }}
      </v-col>
      <v-col
        class="pb-3"
        cols="4">
        Email:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ order.email }}
      </v-col>
      <v-col
        class="pb-3"
        cols="4">
        Tel:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ order.tel }}
      </v-col>
      <v-col
        class="pb-3"
        cols="4">
        ผู้ติดต่อ:
      </v-col>
      <v-col
        class="pb-3"
        cols="8">
        {{ fullName }}
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-data-table
      class="mb-6 _mobile-quotation-table"
      :headers="headers"
      :items="order.orderItems"
      :mobile-breakpoint="0"
      disable-sort
      hide-default-footer>
      <template #item.productName="{ item }">
        {{ item.productName }}
        <div v-if="item.productType === 'package'">
          <div class="_fs-12">
            Basic ID: {{ order.basicId }}
          </div>
          <div class="_fs-10">
            วันที่เริ่มต้นใช้งานแพ็กเกจ: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
            ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
          </div>
        </div>
        <div v-if="item.productType === 'premiumId'">
          <div class="_fs-12">
            Premium ID: {{ item.premiumId }}
          </div>
          <div class="_fs-10">
            วันที่เริ่มต้นใช้งาน Premium ID: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
            ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
          </div>
        </div>
        <div v-if="item.productType === 'oaChat'">
          <div class="_fs-10">
            วันที่เริ่มต้นใช้งาน OA Chat: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
            ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
          </div>
        </div>
      </template>
      <template #item.itemQty="{ item: { itemQty } }">
        {{ itemQty | numberComma }}
      </template>
      <template #item.unitPrice="{ item: { unitPrice } }">
        {{ unitPrice | price }}
      </template>
      <template #item.itemAmount="{ item: { itemAmount } }">
        {{ itemAmount | price }}
      </template>
    </v-data-table>
    <v-card class="pa-4">
      <div class="d-flex justify-space-between">
        <span>ราคาสุทธิสินค้าที่เสียภาษี</span>
        <span>{{ order.preVatAmount | price }} ฿</span>
      </div>
      <div class="pt-2 d-flex justify-space-between">
        <span>ภาษีมูลค่าเพิ่ม</span>
        <span>{{ order.vatAmount | price }} ฿</span>
      </div>

      <template v-if="isDeductWithholding">
        <div class="pt-2 d-flex justify-space-between">
          <span>จำนวนเงินรวมทั้งสิ้น</span>
          <span>{{ order.grandTotal | price }} ฿</span>
        </div>
        <div class="pt-2 d-flex justify-space-between">
          <span>ภาษีถูกหัก ณ ที่จ่าย</span>
          <span>{{ order.withholdingTaxAmount | price }} ฿</span>
        </div>
      </template>

      <v-divider class="my-6"></v-divider>

      <div class="d-flex align-center justify-space-between">
        <span class="font-weight-bold _line-height-initial">จำนวนเงินที่ต้องชำระ</span>
        <span class="font-weight-bold primary--text _fs-28 _line-height-initial">
          {{ isDeductWithholding ? order.netTotal : order.grandTotal | price }} ฿
        </span>
      </div>
    </v-card>
    <div class="error--text mt-3">
      * กรุณาชำระเงินตามยอดในใบเสนอราคาเท่านั้น หากชำระเงินไม่ครบถ้วน
      จะไม่สามารถเปิดให้บริการได้
    </div>

    <v-divider class="my-6"></v-divider>

    <div class="font-weight-bold pb-5">
      หมายเหตุ
    </div>
    <div>
      กรณีโอนเงิน ธนาคารกสิกรไทย<br>
      สาขาเซ็นทรัลพลาซา แกรนด์ พระราม 9
    </div>
    <div class="pt-2">
      ชื่อบัญชี บจก.เซลสุกิ
    </div>
    <div class="pt-2">
      บัญชีออมทรัพย์ เลขที่ 055-1-27809-3
    </div>

    <div class="pt-2">
      Basic ID: {{ order.basicId }}
    </div>

    <div class="pt-2">
      Premium ID: {{ order.premiumId }}
    </div>

    <div
      v-if="order.displayName"
      class="pt-2">
      Display Name: {{ order.displayName }}
    </div>

    <div
      v-if="packageStartedAt"
      class="pt-2">
      วันที่เริ่มต้นใช้งานแพ็กเกจ: {{ packageStartedAt | dateTimeFormat('YYYY-MM-DD') }}
    </div>
    <div
      v-if="packageExpiredAt"
      class="pt-2">
      วันที่หมดอายุใช้งานแพ็กเกจ: {{ packageExpiredAt | dateTimeFormat('YYYY-MM-DD') }}
    </div>
    <div
      v-if="premiumIdStartedAt"
      class="pt-2">
      วันที่เริ่มต้นใช้งาน Premium ID: {{ premiumIdStartedAt | dateTimeFormat('YYYY-MM-DD') }}
    </div>
    <div
      v-if="premiumIdExpiredAt"
      class="pt-2">
      วันที่หมดอายุใช้งาน Premium ID: {{ premiumIdExpiredAt | dateTimeFormat('YYYY-MM-DD') }}
    </div>

    <v-divider class="my-6"></v-divider>

    <div class="d-flex justify-center align-center">
      <span class="pr-2">
        Powered By
      </span>
      <img
        src="../assets/sellsuki-logo.png"
        alt="Sellsuki Logo"
        height="25">
    </div>
  </div>
</template>

<script>
import { getProductName } from '../utils/order.util'

export default {
  name: 'MobileLineDiyQuotation',
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    orderDetailType: {
      type: String,
      default: ''
    },
    basicId: {
      type: String,
      default: ''
    },
    titleTextData: {
      type: Object,
      default: () => ({})
    },
    fullName: {
      type: String,
      default: ''
    },
    companyText: {
      type: String,
      default: ''
    },
    addressText: {
      type: String,
      default: ''
    },
    branchNumberText: {
      type: String,
      default: ''
    },
    validAt: {
      type: Date,
      default: undefined
    },
    packageStartedAt: {
      type: [String, Date],
      default: undefined
    },
    packageExpiredAt: {
      type: [String, Date],
      default: undefined
    },
    premiumIdStartedAt: {
      type: [String, Date],
      default: undefined
    },
    premiumIdExpiredAt: {
      type: [String, Date],
      default: undefined
    },
    grandTotalText: {
      type: String,
      default: ''
    },
    isJuristicCustomer: {
      type: Boolean,
      default: false
    },
    isDeductWithholding: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'รายการ',
          value: 'productName'
        },
        {
          text: 'จำนวน',
          value: 'itemQty',
          align: 'end'
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'unitPrice',
          align: 'end',
          width: '120'
        },
        {
          text: 'มูลค่าก่อนภาษี',
          value: 'itemAmount',
          align: 'end',
          width: '120'
        }
      ]
    }
  },
  methods: {
    getProductName
  }
}
</script>

<style scoped>
._fs-20 {
  font-size: 20px;
}

._fs-28 {
  font-size: 28px;
}

._line-height-initial {
  line-height: initial;
}

._mobile-quotation-table >>> .v-data-table__wrapper > table > thead > tr,
._mobile-quotation-table >>> .v-data-table__wrapper > table > tbody > tr:nth-child(2n) {
  background: #fafafa;
}

._mobile-quotation-table >>> th {
  font-size: 14px;
  font-weight: bold;
}

._mobile-quotation-table >>> td {
  padding: 16px;
}
</style>
